<template>
  <dashboard-page title="Veículos" subtitle="recursos de transporte">
    <template #actions>
      <div class="d-flex align-items-center search-row">
        <div
          class="d-flex align-items-center w-100"
          style="
            padding: 7px;
            border: 0.5px solid rgb(218, 218, 218);
            border-radius: 5px;
            background-color: white;
            min-width: 20rem;
          "
        >
          <input
            class="search-input w-100"
            style="border: none"
            v-model="searchQuery"
            placeholder="buscar"
          />
          <button
            v-if="searchQuery"
            type="button"
            class="vehicle-search-clear"
            title="Limpar busca"
            @click="clearSearchQuery"
          >
            <i class="fas fa-times"></i>
          </button>
          <i v-else class="fas fa-search text-muted"></i>
        </div>
      </div>

      <div class="d-flex align-items-center vehicle-list-header-actions">
        <button
          type="button"
          class="btn-icon-outline vehicle-list-search-toggle search-row-mobile"
          :class="{ active: showSearchQuery }"
          title="Buscar veículo"
          @click="toggleSearchQuery"
        >
          <i class="fas fa-search"></i>
        </button>
      </div>
    </template>

    <div
      v-if="showSearchQuery"
      class="d-flex align-items-center search-row-mobile px-3 mb-3"
    >
      <div
        class="d-flex align-items-center w-100"
        style="
          padding: 7px;
          border: 0.5px solid rgb(218, 218, 218);
          border-radius: 5px;
          background-color: white;
        "
      >
        <input
          class="search-input w-100"
          style="border: none"
          v-model="searchQuery"
          placeholder="buscar"
        />
        <button
          v-if="searchQuery"
          type="button"
          class="vehicle-search-clear"
          title="Limpar busca"
          @click="clearSearchQuery"
        >
          <i class="fas fa-times"></i>
        </button>
        <i v-else class="fas fa-search text-muted"></i>
      </div>
    </div>

    <b-container fluid class="mt-2">
      <card
        class="no-border-card vehicle-list-panel"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <div v-if="isMobileView" class="vehicle-list-cards">
          <div v-if="!queriedData.length" class="text-center text-muted py-4">
            Nenhum veículo encontrado.
          </div>
          <vehicle-list-card
            v-for="(vehicle, index) in queriedData"
            :key="vehicle.uuid || index"
            :vehicle="vehicle"
            @view="openVehicle"
          />
        </div>

        <b-table
          v-else
          :items="queriedData"
          :fields="tableColumns"
          head-variant="light"
          striped
          responsive
          empty-text="Nenhum veículo encontrado."
        >
          <template #cell(image)="data">
            <img
              :src="data.item.image"
              :alt="data.item.name"
              class="vehicle-list-thumb"
            />
          </template>

          <template #cell(fuelName)="data">
            <span v-if="data.item.fuelName" class="vehicle-list-fuel">
              <i
                :class="fuelIconClass(data.item.fuelIcon)"
                aria-hidden="true"
              ></i>
              {{ data.item.fuelName }}
            </span>
            <span v-else class="text-muted">—</span>
          </template>

          <template #cell(capacity)="data">
            {{ capacityLabel(data.item.capacity) }}
          </template>

          <template #cell(acoes)="data">
            <div class="d-flex align-items-center">
              <button
                type="button"
                class="btn-icon mx-1"
                title="Ver veículo"
                @click.prevent="openVehicle(data.item)"
              >
                <i class="text-white no no-view"></i>
              </button>
              <button
                type="button"
                class="btn-icon mx-1 vehicle-edit-button"
                title="Editar registro"
                disabled
              >
                <i class="text-white fas fa-pen"></i>
              </button>
            </div>
          </template>
        </b-table>

        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap align-items-center px-0"
        >
          <div class="d-flex align-items-center flex-wrap mb-2 mb-sm-0">
            <p class="mb-0 mr-3" style="color: gray">
              <el-select
                ref="perPageSelect"
                v-model="pagination.perPage"
                placeholder="Por página"
              >
                <el-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  class="select-primary"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <span
                class="per-page-label font-weight-bold text-primary"
                @click="openPerPageSelect"
              >
                <i class="no no-down-arrow"></i>
                {{ pagination.perPage }}
              </span>
              por página, listando
              <b>{{ from + 1 }}</b> a <b>{{ to }}</b> de
              <span v-if="searchQuery.length">
                <b>{{ total }}</b> item(s) filtrados(s)
              </span>
              <span v-else>
                <b>{{ total }}</b> item(s)
              </span>
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            :value="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @change="paginationChanged($event)"
          />
        </div>
      </card>
    </b-container>

    <vehicle-details-modal
      :visible="showVehicleModal"
      :vehicle="selectedVehicle || {}"
      @close="closeVehicle"
    />
  </dashboard-page>
</template>

<script>
import Card from '@/components/Cards/Card.vue'
import { BasePagination } from '@/components'
import { Select, Option } from 'element-ui'
import usePaginateTable from '../../Composables/usePaginateTable'
import { isMobile } from '../../store/utils/general'
import nodeService from '@/services/nodejs'
import { fuelCategoryFor } from '@/services/nodejs/vehicleResources'
import VehicleListCard from './VehicleListCard.vue'
import VehicleDetailsModal from './VehicleDetailsModal.vue'

export default {
  name: 'VehicleList',

  components: {
    Card,
    BasePagination,
    VehicleListCard,
    VehicleDetailsModal,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  setup(props, context) {
    const paginateTable = usePaginateTable(context)

    return {
      total: paginateTable.total,
      from: paginateTable.from,
      to: paginateTable.to,
      queriedData: paginateTable.queriedData,
      pagination: paginateTable.getPagination(),
      searchQuery: paginateTable.searchQuery,
      createFuseSearch: paginateTable.createFuseSearch,
      setBillItems: paginateTable.setBillsItems,
    }
  },

  data() {
    return {
      showSearchQuery: false,
      isMobileView: isMobile(),
      showVehicleModal: false,
      selectedVehicle: null,
      tableColumns: [
        { key: 'image', label: '', sortable: false, thStyle: { width: '72px' } },
        { key: 'name', label: 'Veículo', sortable: true },
        { key: 'category', label: 'Categoria', sortable: true },
        { key: 'fuelName', label: 'Combustível', sortable: true },
        { key: 'plate', label: 'Placa', sortable: true },
        { key: 'capacity', label: 'Capacidade', sortable: true },
        { key: 'acoes', label: '', sortable: false, thStyle: { width: '110px' } },
      ],
    }
  },

  methods: {
    toggleSearchQuery() {
      this.showSearchQuery = !this.showSearchQuery
    },

    clearSearchQuery() {
      this.searchQuery = ''
    },

    openPerPageSelect() {
      const select = this.$refs.perPageSelect
      if (!select) return
      if (typeof select.focus === 'function') {
        select.focus()
      }
      select.visible = true
    },

    paginationChanged(page) {
      this.pagination.currentPage = page
    },

    capacityLabel(capacity) {
      const count = Number(capacity) || 0
      return count === 1 ? '1 pessoa' : `${count} pessoas`
    },

    fuelIconClass(icon) {
      return String(icon || '').replace(/\bfa-solid\b/g, 'fas')
    },

    openVehicle(vehicle) {
      this.selectedVehicle = vehicle
      this.showVehicleModal = true
    },

    closeVehicle() {
      this.showVehicleModal = false
      this.selectedVehicle = null
    },

    async loadVehicles() {
      const response = await nodeService.getVehicleResources()
      const vehicles = response && Array.isArray(response.data) ? response.data : []
      this.setBillItems(
        vehicles.map((vehicle) => {
          const fuel = fuelCategoryFor(vehicle.fuel_category)
          return {
            ...vehicle,
            fuelName: fuel ? fuel.category : '',
            fuelIcon: fuel ? fuel.icon : '',
          }
        })
      )
      this.createFuseSearch([
        'name',
        'category',
        'plate',
        'description',
        'fuelName',
      ])
    },
  },

  mounted() {
    this.loadVehicles()
  },
}
</script>

<style>
.vehicle-list-header-actions {
  gap: 0.35rem;
}

.vehicle-list-search-toggle.active {
  background-color: #eef5f8;
}

.vehicle-search-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.35rem;
  padding: 0;
  width: 1.35rem;
  height: 1.35rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #9aa5b1;
  cursor: pointer;
  flex-shrink: 0;
}

.vehicle-search-clear:hover {
  background-color: #eef5f8;
  color: #12576e;
}

.vehicle-list-panel .table-responsive,
.vehicle-list-panel .table.b-table {
  width: 100% !important;
}

.vehicle-list-fuel {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.vehicle-list-fuel i {
  width: 1rem;
  color: #12576e;
  text-align: center;
}

.vehicle-list-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
  background: #f3f4f6;
}

.vehicle-edit-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.vehicle-edit-button:disabled:hover {
  background-color: #12576e;
}

.per-page-label {
  cursor: pointer;
  user-select: none;
  margin: 0 0 0.15rem;
  font-weight: normal !important;
  font-size: 1em;
  padding: 0.75rem;
  border-radius: 2px;
}

.per-page-label:hover {
  background-color: #eef5f8 !important;
}

.card-footer .el-select {
  width: 0;
  height: 0;
  overflow: hidden !important;
}
</style>
